<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiProduk",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
